module.exports = __webpack_public_path__ + "static/media/ecommerce.f48700f6.svg";